import type { AiVisibilityRunInfo } from '@cmoh/shared'
import { createContext, useContext } from 'react'
import type { DataDataset } from './types'

export const DataDatasetContext = createContext<DataDataset | null>(null)

export const DataRunInfoContext = createContext<AiVisibilityRunInfo | null>(null)

export function useActiveDataset(): DataDataset {
  const ctx = useContext(DataDatasetContext)
  if (!ctx) {
    throw new Error('useActiveDataset must be used within <DataDatasetProvider>')
  }
  return ctx
}

export function useActiveRunInfo(): AiVisibilityRunInfo {
  const ctx = useContext(DataRunInfoContext)
  if (!ctx) {
    throw new Error('useActiveRunInfo must be used within <DataDatasetProvider>')
  }
  return ctx
}

export interface DataDateRange {
  from: string
  to: string
}

export interface DataRangeSelectionValue {
  range: DataDateRange | null
  setRange: (range: DataDateRange | null) => void
}

export const DataRangeSelectionContext = createContext<DataRangeSelectionValue | null>(null)

export function useDataRangeSelection(): DataRangeSelectionValue {
  const ctx = useContext(DataRangeSelectionContext)
  if (!ctx) {
    throw new Error('useDataRangeSelection must be used within <DataDatasetProvider>')
  }
  return ctx
}
